module.exports = __webpack_public_path__ + "img/bottom-left-corner.57baa18c.svg";